const PRECISION_DECIMALS = 2;
const PRECISION_MULTIPLIER = Math.pow(10, PRECISION_DECIMALS);

/**
 * Baseline normalization where first datapoint is baseline and every other data
 * point is represented at data(t_n)/data(t_0).
 */
export function normalizeTumorBurden(rawTumorBurdenMetrics: number[]) {
  const baseline = rawTumorBurdenMetrics[0] || 1;
  return rawTumorBurdenMetrics.map((tb) => {
    const norm = tb / baseline;
    return Math.round(norm * PRECISION_MULTIPLIER) / PRECISION_MULTIPLIER;
  });
}

/**
 * Percent change from baseline tumor burden, where baseline is 0%.
 */
export function percentTumorBurden(rawTumorBurdenMetrics: number[]) {
  if (rawTumorBurdenMetrics.length === 0) {
    return [];
  }
  const normTBs = normalizeTumorBurden(rawTumorBurdenMetrics);
  return normTBs.map((tb) => Math.round((tb - 1) * 100));
}
